import { Permission } from '@/contexts/AuthContext/permissions';
import type { UsePermissionsReturn } from '@/contexts/AuthContext/usePermissions';

export const OUTCOME_SUMMARY_SYSTEM_PERMISSION = 'outcome_ledger';
export const OUTCOME_SUMMARY_MANAGE_SYSTEM_PERMISSION = 'outcome_ledger:manage';

export const canManageOutcomeSummary = (permissions: UsePermissionsReturn) => (
    permissions.checkPermissions([Permission.OUTCOME_SUMMARY_MANAGE])
);

export const canViewOutcomeSummary = (permissions: UsePermissionsReturn) => (
    canManageOutcomeSummary(permissions)
    || permissions.checkPermissions([Permission.OUTCOME_SUMMARY_VIEW])
);
